import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { UsersListControllerModule } from './controllers/UsersListController';
import { AddUserControllerModule } from './controllers/AddUserController';

export const UsersListView = angular
  .module('acme.view.application.users.list', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    'acme.common.service.api',
    UsersListControllerModule,
    AddUserControllerModule,
    'acme.view.application.dataGrid.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    var usersList = {
      name: 'application.users.list',
      url: '?search&page&deptid&roleid&title',
      views: {
        'subview-main': {
          controller: 'UsersListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/users/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Users',
        permissions: ['USERS_VIEW'],
        roles: ['user'],
        enablePreferences: true,
      },
      resolve: {
        ThemesData: [
          'ApiService',
          function (ApiService) {
            return ApiService.themes.detail();
          },
        ],
      },
    };

    $stateProvider.state(usersList);
  }).name;
